export default "__VITE_ASSET__f868e223__"